import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ConsentFormModal = ({ show, handleClose }) => {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (agreed) {
      handleClose();
    }
  };

  return (
    <>
      <style>
        {`
          .bullet-list {
            list-style-type: disc;
            padding-left: 1.5rem;
          }

          .bullet-list li {
            margin-bottom: 0.5rem;
          }
            .dark-checkbox input[type="checkbox"] {
  accent-color: #000; /* Dark gray or use #000 for black */
}
  .dark-border-checkbox .form-check-input {
  border: 1px solid #333; /* Dark border when not checked */
}

        `}
      </style>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton onClick={() => navigate("/ClinicPatients")}>
          <Modal.Title>Consent Form</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
            <h5 className="h5">Purpose of Consent</h5>
            <p>
              This consent form is intended to provide clear information and
              obtain voluntary authorization from the patient (or their guardian)
              for the use of outpatient medical services, including evaluation,
              diagnosis, consultation, minor therapeutic procedures, use of health
              information systems, and, if needed, telemedicine services.
            </p>

            <h5 className="h5">Scope of Consent</h5>
            <p>
              By signing this form, I voluntarily agree and authorize the
              following:
            </p>

            <h5 className="h5">1. Medical Evaluation and General Treatment</h5>
            <ul className="bullet-list">
              <li>
                I consent to a physical examination, diagnostic investigations
                (e.g., blood tests, X-rays, urine analysis), and standard
                outpatient treatments recommended by the consulting physician(s).
              </li>
              <li>
                I understand that some procedures may carry minimal risks such as
                discomfort, allergic reactions, or side effects.
              </li>
            </ul>

            <h5 className="h5">2. Minor Medical Procedures</h5>
            <ul className="bullet-list">
              <li>
                I give consent for minor procedures that may be performed in an outpatient setting (e.g., wound cleaning, suturing, abscess drainage, nebulization, injections). 
              </li>
              <li>
                I understand I will be informed about any potential complications or alternatives for such procedures. 
              </li>
            </ul>

            <h5 className="h5">3. Medication Administration</h5>
            <ul className="bullet-list">
              <li>
                I authorize the physician and nursing staff to prescribe, administer, and/or dispense medications as per medical requirements.
              </li>
              <li>
                I confirm that I have disclosed any known allergies or prior adverse drug reactions.
              </li>
            </ul>

            <h5 className="h5">4. Diagnostic Imaging and Laboratory Testing</h5>
            <ul className="bullet-list">
              <li>
                I consent to diagnostic services including but not limited to radiology, pathology, and laboratory services. 
              </li>
              <li>
                I understand that these tests are essential for diagnostic accuracy and that results will be explained to me. 
              </li>
            </ul>

            <h5 className="h5">5. Telemedicine Services (if applicable)</h5>
            <ul className="bullet-list">
              <li>
                I understand that consultations may be conducted via video call, phone, or secure online platforms if necessary. 
              </li>
              <li>
                I acknowledge that telemedicine has limitations and that not all conditions may be managed without physical examination.
              </li>
            </ul>

            <h5 className="h5">Data Privacy and Electronic Health Records (EHR)</h5>
            <ul className="bullet-list">
              <li>
                <strong>Use of Electronic Medical Records (EMR)</strong>
                <ul className="bullet-list">
                  <li>I authorize the recording and maintenance of my personal and medical data in the hospital’s EMR system.</li>
                  <li>I understand that my data will be used for documentation, follow-up, quality assurance, and insurance processing.</li>
                </ul>
              </li>
              <li>
                <strong>Data Access and Sharing</strong>
                <ul className="bullet-list">
                  <li>My information may be accessed by authorized healthcare professionals involved in my care.</li>
                  <li>My anonymized health data may be used for research, audits, or public health reporting, unless I opt out.</li>
                </ul>
              </li>
              <li>
                <strong>Confidentiality Assurance</strong>
                <ul className="bullet-list">
                  <li>I understand my information will be stored securely and handled in compliance with applicable data protection laws (e.g., HIPAA, GDPR, or national equivalents).</li>
                  <li>My records will not be shared with third parties without my explicit consent unless required by law or for emergency care.</li>
                </ul>
              </li>
            </ul>

            <h5 className="h5">Financial Responsibility and Insurance</h5>
            <ul className="bullet-list">
              <li>
                I understand that I am responsible for all fees associated with outpatient services rendered, unless otherwise covered by insurance or government schemes.
              </li>
              <li>
                I confirm that I have been informed of consultation fees, investigation costs, and any other applicable charges.
              </li>
              <li>
                I authorize the hospital to share relevant information with my insurance provider for claims processing.
              </li>
            </ul>

            <h5 className="h5">Right to Refuse or Withdraw Consent</h5>
            <ul className="bullet-list">
              <li>I acknowledge that I have the right to decline any part of the treatment or investigations proposed.</li>
              <li>I understand that I may withdraw my consent at any time by informing the attending physician or hospital staff.</li>
              <li>I am aware that withdrawal of consent may impact the continuity or effectiveness of my care.</li>
            </ul>

            <h5 className="h5">Declaration by the Patient/Guardian</h5>
            <ul className="bullet-list">
              <li>I have read and understood the above information in a language I comprehend.</li>
              <li>I have had the opportunity to ask questions and received satisfactory answers.</li>
              <li>
                I understand that this consent is valid for the duration of this outpatient visit 
                and will need to be renewed during each subsequent visit or for any change in the course of treatment.
              </li>
            </ul>

            <Form onSubmit={handleSubmit} className="mt-3">
              <Form.Check
                type="checkbox"
                label="I have read and agree to the terms and conditions above."
                checked={agreed}
                onChange={() => setAgreed(!agreed)}
                className="dark-border-checkbox ms-1"
                style={{borderColor:'red'}}
              />
              <Button
                variant="primary"
                type="submit"
                className="gradient-dark-button mt-3"
                disabled={!agreed}
                
              >
                Accept & Submit
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConsentFormModal;
